import {
  useMutation,
  useQueryClient,
  type UseMutationOptions,
} from '@tanstack/react-query';
import { toast } from '@/shared/hooks/use-toast';
import type { CreatePackPayload, IPack } from '../types';
import { packApi } from '../api';
import { packKeys } from './pack.keys';

export function useCreatePack(
  options?: UseMutationOptions<IPack, Error, CreatePackPayload>
) {
  const queryClient = useQueryClient();
  const { onSuccess: providedOnSuccess, onError: providedOnError, ...mutationOptions } = options ?? {};
  const mutation = useMutation({
    mutationKey: ['packs', 'create'],
    mutationFn: packApi.create,
    ...mutationOptions,
    onSuccess: (data, variables, context) => {
      toast({ title: 'Pack criado com sucesso', variant: 'success' });
      queryClient.invalidateQueries({ queryKey: packKeys.all });
      providedOnSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      toast({
        title: 'Erro ao criar pack',
        description: error.message,
        variant: 'destructive',
      });
      providedOnError?.(error, variables, context);
    },
  });
  return {
    createPack: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
    mutationResult: mutation,
  };
}
